// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.transfers.widget .main.content > div {
  flex-direction: row;
}

.transfers.widget .main.content .section-separator {
  margin-top: 10px;
}

.transfers.widget .main.content .graph {
  flex-grow: 100;
  overflow: hidden;
}

.transfers.widget .main.content .stats {
  margin-left: 10px;
  margin-top: 0px;
  flex: 0 0 auto;
}
`, "",{"version":3,"sources":["webpack://./src/routes/Home/widgets/Transfers/style.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB","sourcesContent":[".transfers.widget .main.content > div {\n  flex-direction: row;\n}\n\n.transfers.widget .main.content .section-separator {\n  margin-top: 10px;\n}\n\n.transfers.widget .main.content .graph {\n  flex-grow: 100;\n  overflow: hidden;\n}\n\n.transfers.widget .main.content .stats {\n  margin-left: 10px;\n  margin-top: 0px;\n  flex: 0 0 auto;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
